import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const BannerApi = createApi({
  reducerPath: "BannerApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["BANNER"],
  endpoints: (build) => ({
    getAllBanners: build.query({
      query: ({ targetAudience = "", isActive = "", search = "", page, limit = 10 } = {}) => {
        const params = new URLSearchParams();
        if (targetAudience) params.append("targetAudience", targetAudience);
        if (isActive !== undefined && isActive !== "") params.append("isActive", isActive);
        if (search) params.append("search", search);
        if (page) params.append("page", page);
        if (limit) params.append("limit", limit);

        return {
          url: `/banners?${params.toString()}`,
          method: "GET",
          headers: { "Content-Type": "application/json; charset=UTF-8" },
        };
      },
      providesTags: ["BANNER"],
    }),

    getBannerById: build.query({
      query: ({ id }) => ({
        url: `/banners/${id}`,
        method: "GET",
        headers: { "Content-Type": "application/json; charset=UTF-8" },
      }),
      providesTags: ["BANNER"],
    }),

    createBanner: build.mutation({
      query: ({ title, subtitle, imageFile, image, actionType, actionValue, targetAudience, position, isActive, startDate, endDate }) => {
        const formData = new FormData();
        if (title) formData.append("title", title);
        if (subtitle) formData.append("subtitle", subtitle);
        if (imageFile) {
          formData.append("image", imageFile);
        } else if (image) {
          formData.append("image", image);
        }
        if (actionType) formData.append("actionType", actionType);
        if (actionValue) formData.append("actionValue", actionValue);
        if (targetAudience) formData.append("targetAudience", targetAudience);
        if (position !== undefined) formData.append("position", position);
        if (isActive !== undefined) formData.append("isActive", isActive);
        if (startDate) formData.append("startDate", startDate);
        if (endDate) formData.append("endDate", endDate);

        return {
          url: `/banners`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["BANNER"],
    }),

    updateBanner: build.mutation({
      query: ({ id, title, subtitle, imageFile, image, actionType, actionValue, targetAudience, position, isActive, startDate, endDate }) => {
        const formData = new FormData();
        if (title !== undefined) formData.append("title", title);
        if (subtitle !== undefined) formData.append("subtitle", subtitle);
        if (imageFile) {
          formData.append("image", imageFile);
        } else if (image) {
          formData.append("image", image);
        }
        if (actionType !== undefined) formData.append("actionType", actionType);
        if (actionValue !== undefined) formData.append("actionValue", actionValue);
        if (targetAudience !== undefined) formData.append("targetAudience", targetAudience);
        if (position !== undefined) formData.append("position", position);
        if (isActive !== undefined) formData.append("isActive", isActive);
        if (startDate !== undefined) formData.append("startDate", startDate);
        if (endDate !== undefined) formData.append("endDate", endDate);

        return {
          url: `/banners/${id}`,
          method: "PUT",
          body: formData,
        };
      },
      invalidatesTags: ["BANNER"],
    }),

    toggleBannerStatus: build.mutation({
      query: ({ id }) => ({
        url: `/banners/${id}/toggle`,
        method: "PATCH",
        headers: { "Content-Type": "application/json; charset=UTF-8" },
      }),
      invalidatesTags: ["BANNER"],
    }),

    deleteBanner: build.mutation({
      query: ({ id }) => ({
        url: `/banners/${id}`,
        method: "DELETE",
        headers: { "Content-Type": "application/json; charset=UTF-8" },
      }),
      invalidatesTags: ["BANNER"],
    }),
  }),
});

export const {
  useGetAllBannersQuery,
  useGetBannerByIdQuery,
  useCreateBannerMutation,
  useUpdateBannerMutation,
  useToggleBannerStatusMutation,
  useDeleteBannerMutation,
} = BannerApi;
